import { cloneObject } from '../../../utilities';

const getYAxisQuill = (_yAxisField, _fields) => {
  const yAxisQuill = {
    ops: [
      {
        insert: {
          inlineValue: {
            fieldName: _yAxisField,
            title: _fields[_yAxisField].title,
            format: cloneObject(_fields[_yAxisField].format),
          },
        },
      },
      { insert: '\n' },
    ],
  };
  return yAxisQuill;
};

export default getYAxisQuill;
